import { useEffect, useState } from "react";
import { supabase } from "../config/supabaseClient";
import FiltreSearch from "../components/FiltreSearch";
import {
  FaPhone, FaEnvelope, FaMapMarkerAlt, FaVenus, FaMars,
  FaTimes, FaChevronLeft, FaChevronRight, FaPaw
} from "react-icons/fa";
import "./AnimaleGasite.css";
import TopBanner from "../components/TopBanner";
import { useLocation } from "react-router-dom";


export default function AnimalePierdute() {

  // în componentă:
  const location = useLocation();
  const [anunturi, setAnunturi] = useState([]);
  const [loading, setLoading] = useState(true);
  const [anuntDeschis, setAnuntDeschis] = useState(null);
  const [pozaActiva, setPozaActiva] = useState(0);

  const fetchAnunturi = async (filtreActive = {}) => {
    setLoading(true);
     let query = supabase
  .from("anunturi")
  .select("*")
  .eq("tip", "pierdut")  // ← corectat
  .eq("activ", true)
  .order("promovat", { ascending: false })
  .order("created_at", { ascending: false });

    if (filtreActive.specie) query = query.eq("specie", filtreActive.specie);
    if (filtreActive.rasa) query = query.eq("rasa", filtreActive.rasa);
    if (filtreActive.sex) query = query.eq("sex", filtreActive.sex);
    if (filtreActive.culoare) query = query.eq("culoare", filtreActive.culoare);
    if (filtreActive.oras) query = query.eq("oras", filtreActive.oras);

    const { data, error } = await query;
    if (!error) setAnunturi(data || []);
    setLoading(false);
  };

  
useEffect(() => {
  const params = new URLSearchParams(location.search);
  
  // Dacă există ids din AI search de pe homepage
  const idsParam = params.get("ids");
  if (idsParam) {
    const ids = idsParam.split(",");
    setLoading(true);
    supabase
      .from("anunturi")
      .select("*")
      .in("id", ids)
      .eq("activ", true)
      .eq("tip", "pierdut")
      .then(({ data, error }) => {
        if (!error) setAnunturi(data);
        setLoading(false);
      });
    return;
  }

  // Filtrare normală după text
  const filtreURL = {
    specie: params.get("specie") || "",
    rasa: params.get("rasa") || "",
    sex: params.get("sex") || "",
    culoare: params.get("culoare") || "",
    oras: params.get("oras") || "",
  };
  fetchAnunturi(filtreURL);
}, [location.search]);

  const deschideAnunt = (a) => {
    setAnuntDeschis(a);
    setPozaActiva(0);
    document.body.style.overflow = "hidden";
  };

  const inchideAnunt = () => {
    setAnuntDeschis(null);
    document.body.style.overflow = "auto";
  };

  const pozaPrecedenta = (e) => {
    e.stopPropagation();
    const imagini = anuntDeschis?.imagini || [];
    setPozaActiva((prev) =>
      prev === 0 ? imagini.length - 1 : prev - 1
    );
  };

  const pozaUrmatoare = (e) => {
    e.stopPropagation();
    const imagini = anuntDeschis?.imagini || [];
    setPozaActiva((prev) =>
      prev === imagini.length - 1 ? 0 : prev + 1
    );
  };

  return (
    <div className="animale-page">
      <TopBanner style={{ marginBottom: "20px" }} className="news-banner" />
<FiltreSearch
  tip="pierdut"
  onCauta={async ({ filtre, rezultateAI, reset }) => {
    if (reset) { fetchAnunturi(); return; }

    setLoading(true);

    if (rezultateAI && rezultateAI.length > 0) {
      let query = supabase
        .from("anunturi")
        .select("*")
        .in("id", rezultateAI)
        .eq("activ", true)
        .eq("tip", "pierdut"); // ← pierdut

      if (filtre.specie) query = query.eq("specie", filtre.specie);
      if (filtre.rasa) query = query.eq("rasa", filtre.rasa);
      if (filtre.sex) query = query.eq("sex", filtre.sex);
      if (filtre.culoare) query = query.eq("culoare", filtre.culoare);
      if (filtre.oras) query = query.eq("oras", filtre.oras);

      const { data, error } = await query;
      if (!error && data) {
        const sortate = rezultateAI
          .map(id => data.find(a => a.id === id))
          .filter(Boolean);
        setAnunturi(sortate);
      }
    } else if (rezultateAI !== null && rezultateAI !== undefined) {
      setAnunturi([]);
    } else {
      fetchAnunturi(filtre);
    }

    setLoading(false);
  }}
/>

      {loading ? (
        <p className="loading-text">Se încarcă anunțurile...</p>
      ) : anunturi.length === 0 ? (
        <div className="no-results">
          <FaPaw size={40} color="#ddd" />
          <p>Nu există anunțuri pentru filtrele selectate.</p>
        </div>
      ) : (
        <div className="anunturi-grid">
          {anunturi.map((a) => (
            <div
              key={a.id}
              className="anunt-card-public"
              onClick={() => deschideAnunt(a)}
            >
              <div className="card-imagine">
  {a.imagini?.[0] ? (
    <img src={a.imagini[0]} alt="animal gasit" />
  ) : (
    <div className="no-image-placeholder">📷</div>
  )}
  {a.imagini?.length > 1 && (
    <span className="card-poza-count">
       {a.imagini.length}
    </span>
  )}
  {a.promovat && (
    <span className="card-promovat-badge">⭐ Promovat</span>
  )}
</div>

              <div className="card-info">
                <div className="card-titlu">
                  <strong>{a.specie === "caine" ? "Caine" : "Pisica"} {a.rasa}</strong>
                  <span className="card-data">
                    {new Date(a.created_at).toLocaleDateString("ro-RO")}
                  </span>
                </div>

                <div className="card-detalii">
                  <span><FaMapMarkerAlt /> {a.oras}</span>
                  <span>
                    {a.sex === "mascul"
                      ? <FaMars color="#3b82f6" />
                      : a.sex === "femela"
                      ? <FaVenus color="#ec4899" />
                      : "?"}
                  </span>
                  <span>🎨 {a.culoare}</span>
                </div>

                {a.detalii && <p className="card-descriere">{a.detalii}</p>}

                <div className="card-contact">
                  {a.telefon && (
                    <a href={`tel:${a.telefon}`} onClick={(e) => e.stopPropagation()}>
                      <FaPhone /> {a.telefon}
                    </a>
                  )}
                  {a.email && (
                    <a href={`mailto:${a.email}`} onClick={(e) => e.stopPropagation()}>
                      <FaEnvelope /> {a.email}
                    </a>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Modal */}
      {anuntDeschis && (
        <div className="modal-overlay" onClick={inchideAnunt}>
          <div className="modal-anunt" onClick={(e) => e.stopPropagation()}>

            <button className="modal-inchide" onClick={inchideAnunt}>
              <FaTimes />
            </button>

            <div className="modal-galerie">
              {anuntDeschis.imagini?.length > 0 ? (
                <>
                  <img
                    src={anuntDeschis.imagini[pozaActiva]}
                    alt={`poza ${pozaActiva + 1}`}
                    className="modal-poza-principala"
                  />

                  {anuntDeschis.imagini.length > 1 && (
                    <>
                      <button className="btn-poza-nav prev" onClick={pozaPrecedenta}>
                        <FaChevronLeft />
                      </button>
                      <button className="btn-poza-nav next" onClick={pozaUrmatoare}>
                        <FaChevronRight />
                      </button>

                      <div className="modal-thumbnails">
                        {anuntDeschis.imagini.map((src, i) => (
                          <img
                            key={i}
                            src={src}
                            alt={`thumb ${i + 1}`}
                            className={`thumbnail ${i === pozaActiva ? "activ" : ""}`}
                            onClick={(e) => { e.stopPropagation(); setPozaActiva(i); }}
                          />
                        ))}
                      </div>

                      <div className="modal-poza-index">
                        {pozaActiva + 1} / {anuntDeschis.imagini.length}
                      </div>
                    </>
                  )}
                </>
              ) : (
                <div className="modal-no-image">
                  <FaPaw size={48} color="#ddd" />
                </div>
              )}
            </div>

            <div className="modal-detalii">
              <div className="modal-titlu">
                <h2>{anuntDeschis.specie === "caine" ? "Caine" : "Pisica"} {anuntDeschis.rasa}</h2>
                <span className="badge-tip pierdut">🔴 Pierdut</span>
              </div>

              <div className="modal-info-grid">
                <div className="modal-info-item">
                  <span className="label">Specie</span>
                  <span>{anuntDeschis.specie === "caine" ? "Câine" : "Pisică"}</span>
                </div>
                <div className="modal-info-item">
                  <span className="label">Rasă</span>
                  <span>{anuntDeschis.rasa || "—"}</span>
                </div>
                <div className="modal-info-item">
                  <span className="label">Sex</span>
                  <span>
                    {anuntDeschis.sex === "mascul"
                      ? <><FaMars color="#3b82f6" /> Mascul</>
                      : anuntDeschis.sex === "femela"
                      ? <><FaVenus color="#ec4899" /> Femelă</>
                      : "Necunoscut"}
                  </span>
                </div>
                <div className="modal-info-item">
                  <span className="label">Culoare</span>
                  <span>{anuntDeschis.culoare || "—"}</span>
                </div>
                <div className="modal-info-item">
                  <span className="label"><FaMapMarkerAlt /> Oraș</span>
                  <span>{anuntDeschis.oras || "—"}</span>
                </div>
                <div className="modal-info-item">
                  <span className="label">Data</span>
                  <span>{new Date(anuntDeschis.created_at).toLocaleDateString("ro-RO")}</span>
                </div>
              </div>

              {anuntDeschis.detalii && (
                <div className="modal-descriere">
                  <span className="label">Detalii</span>
                  <p>{anuntDeschis.detalii}</p>
                </div>
              )}

              <div className="modal-contact">
                <h4>Contact</h4>
                {anuntDeschis.telefon && (
                  <a href={`tel:${anuntDeschis.telefon}`} className="contact-btn">
                    <FaPhone /> {anuntDeschis.telefon}
                  </a>
                )}
                {anuntDeschis.email && (
                  <a href={`mailto:${anuntDeschis.email}`} className="contact-btn">
                    <FaEnvelope /> {anuntDeschis.email}
                  </a>
                )}
              </div>
            </div>

          </div>
        </div>
      )}
    </div>
  );
}